import { ecsClient, getGlobalSessionId } from "./index";
import { UserProfile } from "@/types";

const ProfileService = {
  getUserProfile: async (): Promise<UserProfile | null> => {
    try {
      const sessionId = getGlobalSessionId();
      if (!sessionId) {
        console.error("No session ID found for getUserProfile");
        return null;
      }

      const response = await ecsClient.get<UserProfile>("/user-profile", {
        params: { sessionId },
      });

      return response.data || null;
    } catch (error: any) {
      console.error("❌ Get user profile error:", {
        error: error,
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      return null;
    }
  },

  updateUserProfile: async (
    profileData: Partial<UserProfile>
  ): Promise<UserProfile | null> => {
    try {
      const sessionId = getGlobalSessionId();
      if (!sessionId) {
        console.error("No session ID found for updateUserProfile");
        return null;
      }

      const response = await ecsClient.post<UserProfile>(
        `/user-profile?sessionId=${sessionId}`,
        profileData
      );

      return response.data || null;
    } catch (error: any) {
      console.error("❌ Update user profile error:", {
        error: error,
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      throw error;
    }
  },

  hasRequiredProfileFields: (profile?: UserProfile | null): boolean => {
    if (!profile) return false;

    return !!(profile.firstName && profile.lastName && profile.phoneNumber);
  },
};

export default ProfileService;
